import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import classes from './trackedUntrackedAction.module.scss';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import React, { useState } from 'react';
import { LoaderSpinner } from 'components/common/LodaerSpinner/LoaderSpinner';
import { useQueryClient } from 'react-query';
import { useMutationTrackUnTrackItems } from 'components/common/TrackedUntrackedAction/queries/trackedMutation';
import { MuiIcon } from 'components/common/muiIcon/muiIcon';
import { useProjectTreeStore } from 'store/projectContract.store';
import { kebabCase } from 'lodash';

interface ITrackedUntrackedActionProps {
    taskVersionHashCode: string;
    isTracked?: boolean;
    invalidateQueriesKey: string[];
    dataTrackId?: string;
}

export const TrackedUntrackedAction = ({
    isTracked = false,
    taskVersionHashCode,
    invalidateQueriesKey,
    dataTrackId = '',
}: ITrackedUntrackedActionProps) => {
    const { handleSnackBar } = useCustomSnackBar();
    const { mutate, isLoading } = useMutationTrackUnTrackItems();
    const queryClient = useQueryClient();

    const [isLoadingInvalidateQueries, setIsLoadingInvalidateQueries] = useState<boolean>(false);
    const { contract } = useProjectTreeStore();

    const handleTrackActivity = (e: React.MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();

        setIsLoadingInvalidateQueries(true);

        mutate(
            {
                taskVersionHashCode: taskVersionHashCode,
                toTrack: !isTracked,
                contractId: contract?.id,
            },
            {
                onSuccess: () => {
                    return Promise.all(invalidateQueriesKey.map((key) => queryClient.invalidateQueries(key))).then(
                        () => {
                            setIsLoadingInvalidateQueries(false);
                            isTracked
                                ? handleSnackBar('Removed From Track Activities', 'success')
                                : handleSnackBar('Added To Track Activities', 'success');
                        },
                    );
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    setIsLoadingInvalidateQueries(false);
                },
            },
        );
    };

    return (
        <div className={classes.trackedUntrackedActionContainer}>
            {isLoading || isLoadingInvalidateQueries ? (
                <LoaderSpinner />
            ) : isTracked ? (
                <CustomizedTooltip
                    tooltipContent={'Tracked Activity'}
                    triggerElement={
                        <MuiIcon
                            icon="star"
                            color="#FFE78D"
                            fontSize="3rem"
                            onClick={handleTrackActivity}
                            data-track-id={kebabCase(`Tracked-Untracked-Action-Tracked-Activity ${dataTrackId}`)}
                        />
                    }
                />
            ) : (
                <CustomizedTooltip
                    tooltipContent={'Click to set as Tracked Activity'}
                    triggerElement={
                        <MuiIcon
                            icon="star_outline"
                            color="#7c838c"
                            fontSize="3rem"
                            onClick={handleTrackActivity}
                            data-track-id={kebabCase(`Tracked-Untracked-Action-un-Tracked-Activity ${dataTrackId}`)}
                        />
                    }
                />
            )}
        </div>
    );
};
